// extracted by mini-css-extract-plugin
module.exports = {"container":"Totals__container___IDBar","tooltip":"Totals__tooltip___11Igx Link__container___LgiZs"};